import { render, staticRenderFns } from "./PetFriendly.vue?vue&type=template&id=640b1760&"
import script from "./PetFriendly.vue?vue&type=script&lang=js&"
export * from "./PetFriendly.vue?vue&type=script&lang=js&"
import style0 from "./PetFriendly.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports